import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const SchoolIcon: React.FC<IconProps> = (props) => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps, ...props
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
    >
      <path
        d="M6.0502 17.775C5.71686 17.5917 5.45853 17.3459 5.2752 17.0375C5.09186 16.7292 5.0002 16.3834 5.0002 16V11.2L2.6002 9.87502C2.41686 9.77502 2.28353 9.65002 2.2002 9.50002C2.11686 9.35002 2.0752 9.18336 2.0752 9.00002C2.0752 8.81669 2.11686 8.65002 2.2002 8.50002C2.28353 8.35002 2.41686 8.22502 2.6002 8.12502L11.0502 3.52502C11.2002 3.44169 11.3544 3.37919 11.5127 3.33752C11.671 3.29586 11.8335 3.27502 12.0002 3.27502C12.1669 3.27502 12.3294 3.29586 12.4877 3.33752C12.646 3.37919 12.8002 3.44169 12.9502 3.52502L22.4752 8.72502C22.6419 8.80836 22.771 8.92919 22.8627 9.08752C22.9544 9.24586 23.0002 9.41669 23.0002 9.60002V16C23.0002 16.2834 22.9044 16.5209 22.7127 16.7125C22.521 16.9042 22.2835 17 22.0002 17C21.7169 17 21.4794 16.9042 21.2877 16.7125C21.096 16.5209 21.0002 16.2834 21.0002 16V10.1L19.0002 11.2V16C19.0002 16.3834 18.9085 16.7292 18.7252 17.0375C18.5419 17.3459 18.2835 17.5917 17.9502 17.775L12.9502 20.475C12.8002 20.5584 12.646 20.6209 12.4877 20.6625C12.3294 20.7042 12.1669 20.725 12.0002 20.725C11.8335 20.725 11.671 20.7042 11.5127 20.6625C11.3544 20.6209 11.2002 20.5584 11.0502 20.475L6.0502 17.775ZM12.0002 12.7L18.8502 9.00002L12.0002 5.30002L5.1502 9.00002L12.0002 12.7ZM12.0002 18.725L17.0002 16.025V12.25L12.9752 14.475C12.8252 14.5584 12.6669 14.6209 12.5002 14.6625C12.3335 14.7042 12.1669 14.725 12.0002 14.725C11.8335 14.725 11.6669 14.7042 11.5002 14.6625C11.3335 14.6209 11.1752 14.5584 11.0252 14.475L7.0002 12.25V16.025L12.0002 18.725Z"
        fill={color}
      />
    </svg>
  );
};

export default SchoolIcon;
